export default "__VITE_ASSET__4b447477__"